import React, { FC } from 'react';
import { BOOKING_STEPS } from '../../utils/booking-flow';

// The four booking steps plus the confirmation, as in the mockup's step bar.
const LABELS = [...BOOKING_STEPS, 'Confirmed'];

const BookingProgress: FC<{ current: number }> = ({ current }) => {
  const complete = current >= BOOKING_STEPS.length;

  return (
    <nav aria-label="Booking progress">
      <ol className="steps">
        {LABELS.map((label, i) => {
          const state = (i < current && 'done') || (i === current && 'now') || '';
          return (
            <li key={label} className={`stp ${state}`} aria-current={i === current ? 'step' : undefined}>
              <div className="bar" />
              <div className="lb">
                <span className="tick" aria-hidden>✓</span>
                {label}
              </div>
            </li>
          );
        })}
      </ol>
      <div className="stepcount">
        {complete ? 'Booking complete' : `Step ${current + 1} of ${BOOKING_STEPS.length} · ${BOOKING_STEPS[current]}`}
      </div>
    </nav>
  );
};

export default BookingProgress;
